import type { IResponseSerialized, IResponseSerializer } from '../interface/responseSerializer';

function _serializeHeaders(headers: Headers): Record<string, string> {
    const serialized: Record<string, string> = {};

    headers.forEach((value, key) => {
        serialized[key] = value;
    });

    return serialized;
}

function serializeResponse(response: Response): Promise<IResponseSerialized> {
    const serialized: IResponseSerialized = {
        headers: _serializeHeaders(response.headers),
        status: response.status,
        statusText: response.statusText,
        body: '',
    };

    return response
        .clone()
        .text()
        .then(body => {
            serialized.body = body;
            return Promise.resolve(serialized);
        });
}

function deserializeResponse(data: IResponseSerialized): Response {
    const response = new Response(data.body, data);
    return response;
}

function serializer(): IResponseSerializer {
    const val: IResponseSerializer = {
        serialize: serializeResponse,
        parse: deserializeResponse,
    };

    return val;
}

export default serializer;
